// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Retomada_ListaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Resposta de /retomada/lista (chamado 2026-0021).
 *
 * Lista vazia e o estado NORMAL e bom: quer dizer que nenhum cliente passou do
 * prazo de retorno. A tela precisa dizer isso com todas as letras, em vez de
 * parecer que falhou ao carregar.
 */
import type { Retomada_ClienteRow } from './Retomada_ClienteRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Retomada_ListaResponseDados = Retomada_ClienteRow[];

export type Retomada_ListaResponse = ApiResponse<Retomada_ListaResponseDados>;

registerResponseContract('Retomada_ListaResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      cliente_id:             { type: 'number',  required: false },
      cliente_nome:           { type: 'string',  required: false },
      cliente_ddi:            { type: 'string',  required: false },
      cliente_ddd:            { type: 'string',  required: false },
      cliente_telefone:       { type: 'string',  required: false },
      cliente_email:          { type: 'string',  required: false },
      cliente_franquia_id:    { type: 'number',  required: false },
      franquia:               { type: 'string',  required: false },
      servicoscategoria_id:   { type: 'string',  required: false },
      servicoscategoria_nome: { type: 'string',  required: false },
      prazo_dias:             { type: 'number',  required: false },
      ultimo_servico:         { type: 'string',  required: false },
      vence_em:               { type: 'string',  required: false },
      dias_vencido:           { type: 'number',  required: false },
      whatsapp_numero:        { type: 'string',  required: false },
      contatado:              { type: 'boolean', required: false },
      contato_id:             { type: 'number',  required: false },
      contato_em:             { type: 'string',  required: false },
      contato_canal:          { type: 'string',  required: false },
      contato_por:            { type: 'string',  required: false },
    },
  },
})
